<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
            <v-card class="mb-2 background-2 round-card" ref="notificationssetting">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title> 
                <v-divider></v-divider>

                <v-subheader class="pl-4">Prodotto rappresentanto il noleggio di un Cassone per i Documenti</v-subheader>
                <v-list two-line subheader class="background-2 px-2 pt-0">
                    <v-list-item>
                        <v-list-item-content style="height: 90px; padding-top: 24px;">
                            <v-col cols="12" lg="4">
                                <v-text-field
                                    label="Codice per prodotto Cassone Socio"
                                    v-model="settings['partner_container_product_code']"
                                    outlined
                                    dense
                                ></v-text-field> 
                            </v-col>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-list two-line subheader class="background-2 px-2 pt-0">
                    <v-list-item>
                        <v-list-item-content style="height: 90px; padding-top: 24px;">
                            <v-col cols="12" lg="4">
                                <v-text-field
                                    label="Codice per prodotto Cassone Non Socio"
                                    v-model="settings['no_partner_container_product_code']"
                                    outlined
                                    dense
                                ></v-text-field> 
                            </v-col>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-subheader class="pl-4">Sezionale per la fatturazione dei Noleggi Cassoni</v-subheader>
                <v-list two-line subheader class="background-2 px-2 pt-0">
                    <v-list-item>
                        <v-list-item-content style="height: 90px; padding-top: 24px;">
                            <v-col cols="12" lg="4">
                                <v-autocomplete
                                    label="Sezionale"
                                    :items="sectionals"
                                    v-model="settings['sectional_id']"
                                    :menu-props="{maxHeight:'200', nudgeBottom: 3}"
                                    outlined
                                    dense>
                                </v-autocomplete> 
                            </v-col>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

    export default {
        name: 'agribios-options',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'agribios',
                sectionals: [],
                settings: {
                    'partner_container_product_code': null,
                    'no_partner_container_product_code': null,
                    'sectional_id': null,
                },
            }
        },

        created() {
            this.axios.post('getoptionfields/', {model: 'Sectional', relation_field: 'name', key: 'text', value: 'value'}).then(response => {
				this.sectionals = response.data.option_fields
                this.loading = false
            }, response => {
                // error callback
            })            
        }

    }
</script>

<style scoped>

</style>